export default __webpack_public_path__ + "static/media/023-sri lanka.c0eeff43.svg";